export const LIMIT_STAT_DATA = 5;
export const STATS_DATA_KEY = "types";
export const FILTER_KEY = "type.name";
export const STAT_COLORS = {
  0: "#0072a1",
  1: "#6074bc",
  2: "#ae6cbc",
  3: "#ff6c69",
  4: "#ff912b",
  others: "#cccccc",
};
